import type { Observable } from 'rxjs';
import type { HttpDataResponse } from '@common/types/http-response.type';

import { Injectable } from '@angular/core';
import { shareReplay } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseHttpService } from '@common/services/REST/base.http.service';
import type { Testimonial } from '@common/types/testimonial.type';

@Injectable({
    providedIn: 'root',
})
export class TestimonialsHttpService extends BaseHttpService {
    public getTestimonials(courseId: number): Observable<Testimonial[]> {
        return this.http
            .get<HttpDataResponse<Testimonial[]>>(this.formatApiUrl(`education/courses/${courseId}/feedbacks`))
            .pipe(
                shareReplay(),
                map((data: HttpDataResponse<Testimonial[]>) => data.data)
            );
    }
}
